import { PartialBlock, DefaultBlockSchema } from '@packages/blocknote-core'
import { Note } from '../../../utils/note'
import { TaskItem } from '../../../modules/filter/types'
import { RenderableItem, ItemType, ItemMetadata } from './types'
import { type SearchContentResult } from '../../../modules/search/Search'

export function createRenderableItem(
  type: ItemType,
  content: PartialBlock<DefaultBlockSchema> | Note | TaskItem | string,
  metadata: Partial<ItemMetadata>
): RenderableItem {
  return {
    type,
    content,
    metadata: {
      recordName: '',
      noteType: 0,
      lineIndex: 0,
      ...metadata,
    },
  }
}

// Factory functions for common item types
export function createSearchResultItem(
  result: SearchContentResult,
  keyword?: string
): RenderableItem {
  return createRenderableItem('block', result.block, {
    recordName: result.recordName,
    noteType: result.noteType,
    lineIndex: result.lineIndex,
    expectedContent: result.content,
    keyword,
  })
}

export function createFilterTaskItem(
  task: TaskItem,
  context?: string
): RenderableItem {
  return createRenderableItem('task', task, {
    recordName: task.sourceNote.recordName ?? '',
    noteType: task.sourceNote.noteType,
    lineIndex: task.lineIndex,
    expectedContent: task.originalLine, // Use the original line content for accurate task finding
    sourceNote: task.sourceNote,
    scheduledDate: task.scheduledDate,
    context, // Pass context for task state determination
  })
}

export function createFilterNoteItem(note: Note): RenderableItem {
  return createRenderableItem('note', note, {
    recordName: note.recordName ?? '',
    noteType: note.noteType,
    sourceNote: note,
  })
}
